export const DEFAULT_RESPONSIBE_RULES = [
  {
    condition: {
      maxWidth: 500
    },
    chartOptions: {
      title: {
        x: 0
      },
      legend: {
        align: 'center',
        verticalAlign: 'bottom',
        layout: 'horizontal'
      },
      pane: {
        size: '70%'
      }
    }
  }
]

export const CHARTS_OPTIONS = {
  polar: true,
  type: 'area',
  spacing: [10, 10, 10, 10]
}

export const ACCESSIBILITY_OPTIONS = {
  enabled: true,
  keyboardNavigation: {
    enabled: true,
    focusBorder: {
      style: {
        lineWidth: 3,
        color: 'black',
        borderRadius: 5
      },
      margin: 4
    }
  }
}
